import * as React from "react";
import AppBar from "@mui/material/AppBar";
import {
  Box,
  Container,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";

import CloudIcon from "@mui/icons-material/Cloud";
import FreeBreakfastIcon from "@mui/icons-material/FreeBreakfast";

import analytics from "../analytics";

function ResponsiveAppBar() {
  return (
    <AppBar position="static" color="transparent" sx={{ boxShadow: "none" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <CloudIcon sx={{ mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              color: "inherit",
              textDecoration: "none",
            }}
          >
            CloudFormation
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}></Box>

          <Box
            sx={{ flexGrow: 0 }}
            onClick={(e) => {
              e.preventDefault();
              analytics.track("new coffee visitor");
              window.open("https://www.buymeacoffee.com/norahsakal", "_blank");
            }}
          >
            <Typography sx={{ "&:hover": { cursor: "pointer" } }}>
              Buy me a coffee
              <Tooltip title="Buy me a coffee or a mimosa">
                <IconButton
                  onClick={(e) => {
                    e.preventDefault();
                    analytics.track("new coffee visitor");
                    window.open(
                      "https://www.buymeacoffee.com/norahsakal",
                      "_blank"
                    );
                  }}
                  sx={{ ml: 1, p: 0, color: "black" }}
                >
                  <FreeBreakfastIcon />
                </IconButton>
              </Tooltip>
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
